export const travellerType = {
    ADULTS: 'adults',
    CHILDREN: 'children',
    BABIES: 'babies'
}
